import HyperLink from "./reusables/HyperLink";

function NavBar({ links, className, showBackIcon, goBackTo }) {
    return(
        <div className={className}>
            {links.map((link, index) => (
                <HyperLink key={index} link={link} />
            ))}
            {showBackIcon && (
                <button onClick={goBackTo} className="backButton">
                    <i id="backIcon" class="fa-solid fa-arrow-right-from-bracket"></i>
                </button>
            )}
        </div>
    );
}

export default NavBar;
